import { render, staticRenderFns } from "./Fluxo.vue?vue&type=template&id=6aca33a7&"
import script from "./Fluxo.vue?vue&type=script&lang=js&"
export * from "./Fluxo.vue?vue&type=script&lang=js&"
import style0 from "./Fluxo.vue?vue&type=style&index=0&id=6aca33a7&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports